import Raven from 'raven-js'
import React from 'react'
import { ApolloProvider } from '@apollo/client'
import { BrowserRouter, Route } from 'react-router-dom'
import { QueryParamProvider } from 'use-query-params'

import PropTypes from 'prop-types'
import Application from '../shared/components/application'
import {
  CONFIG_KEYS,
  getClientConfigValue,
} from '../shared/helpers/config-helper'
import '../shared/assets/sass/global.scss'
import { whitelistUrls } from '../../config/sentry-url-whitelist'
import FeatureFlagsProvider from '../shared/components/feature-flags-provider'
import { EvolvedContext } from '../shared/context'
import ApplicationWrapper from './components/application-wrapper'
import apolloClient from './apollo-client'

Raven.config(getClientConfigValue(CONFIG_KEYS.NEXT_PUBLIC_SENTRY_DSN), {
  environment: getClientConfigValue(CONFIG_KEYS.NEXT_PUBLIC_SENTRY_ENV),
  whitelistUrls,
}).install()

const ClientApp = ({ isHmr }) => {
  // Make sure dynamic imports always request files from the asset host in prod.
  // eslint-disable-next-line camelcase
  __webpack_public_path__ = `${
    getClientConfigValue('NEXT_PUBLIC_ASSET_HOST') || ''
  }/`
  return (
    <EvolvedContext.Provider value={false}>
      <FeatureFlagsProvider doGetFromEnv>
        <BrowserRouter>
          <QueryParamProvider ReactRouterRoute={Route}>
            <ApolloProvider client={apolloClient(isHmr)}>
              <ApplicationWrapper>
                <Application />
              </ApplicationWrapper>
            </ApolloProvider>
          </QueryParamProvider>
        </BrowserRouter>
      </FeatureFlagsProvider>
    </EvolvedContext.Provider>
  )
}

ClientApp.propTypes = {
  isHmr: PropTypes.bool,
}

ClientApp.defaultProps = {
  isHmr: false,
}

export default ClientApp
